/**
 * Компонент баннера с информацией о промокоде
 *
 * Отображается когда промокод успешно применён
 * Показывает код и процент скидки
 */
import React from 'react';
import { useLanguage } from '../../../contexts/LanguageContext';
import { PromoInfo } from '../types';

interface PromoInfoBannerProps {
  promo: PromoInfo;
}

export const PromoInfoBanner: React.FC<PromoInfoBannerProps> = ({ promo }) => {
  const { t } = useLanguage();

  // Не показываем баннер если промокод невалиден
  if (!promo.is_valid || !promo.code) {
    return null;
  }

  return (
    <div className="mt-4 p-4 bg-gradient-to-r from-green-50 to-emerald-50 border-2 border-green-300 rounded-lg shadow-sm">
      <div className="flex items-center gap-3">
        {/* Иконка успеха */}
        <div className="flex-shrink-0 w-10 h-10 bg-green-500 rounded-full flex items-center justify-center">
          <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 20 20">
            <path
              fillRule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
              clipRule="evenodd"
            />
          </svg>
        </div>

        {/* Текст */}
        <div className="flex-1">
          <p className="text-green-900 font-semibold text-lg">
            {t('addOrder.promoApplied')}
          </p>
          <p className="text-green-700 mt-1">
            <span className="font-mono font-bold text-xl">{promo.code}</span>
            <span className="ml-2 text-sm">
              • {t('addOrder.discount')}:{' '}
              <span className="font-bold">{promo.discount_percent}%</span>
            </span>
          </p>
        </div>

        {/* Бейдж со скидкой */}
        <div className="flex-shrink-0 px-4 py-2 bg-green-500 text-white rounded-full font-bold text-lg">
          -{promo.discount_percent}%
        </div>
      </div>
    </div>
  );
};
